import { apiClient } from "../../../zodios/client";

type StaffOrganizationsResponse = Awaited<ReturnType<typeof apiClient.listStaffOrganizations>>;

export const getStaffOrganizationsInfiniteOptions = ({
  search,
  enabled = true,
  limit = 50,
}: { search?: string; enabled?: boolean; limit?: number } = {}) => ({
  queryKey: [{ entity: "staffOrganizations", scope: "infinite", search, limit }],
  queryFn: async ({ pageParam }: { pageParam: number }) =>
    await apiClient.listStaffOrganizations({
      queries: { limit, page: pageParam, ...(search ? { search } : {}) },
    }),
  initialPageParam: 1,
  getNextPageParam: (lastPage: StaffOrganizationsResponse, pages: StaffOrganizationsResponse[]) =>
    lastPage.next ? pages.length + 1 : undefined,
  enabled,
});
